import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Drawer from "@material-ui/core/Drawer";
import {ListItem} from "@material-ui/core";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import TocRoundedIcon from '@material-ui/icons/TocRounded';
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import {Translate} from "../../../../config/Translate";
import BorderColorRoundedIcon from '@material-ui/icons/BorderColorRounded';
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
class PlayerPage extends React.Component {
    state = {
        open:false,
        query:'',
        tab:'toc',
        current_chapter:null,
        chapters:[],
        selections:[],
    };
    classes = this.props.classes;
    componentDidMount() {
        this.setState({
            chapters:this.props.chapters,
            selections:this.props.selections,
            current_chapter:this.props.current_chapter
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.chapters !== this.state.chapters){
            this.setState({
                chapters:this.props.chapters
            })
        }
        if(this.props.current_chapter !== this.state.current_chapter){
            this.setState({
                current_chapter:this.props.current_chapter
            })
        }
        if(this.props.selections !== this.state.selections){
            this.setState({
                selections:this.props.selections
            })
        }
    }
    toggleDrawer(){
        let{open} = this.state;
        this.setState({
            open:!open
        })
    }
    handleClick(cfi){
        this.props.handleClick(cfi);
        this.toggleDrawer();
    }
    handleShow(selection){
        this.props.handleShow(selection);
        this.toggleDrawer();
    }
    handleRemove(selection){
        this.props.handleRemove(selection);
    }
    handleTabChange(event, newValue){
        this.setState({
            tab:newValue
        })
    }
    render(){
        let {open,query,chapters,current_chapter,tab,selections} = this.state;
        let current_href = null;
        if(!!current_chapter){
            current_href = current_chapter.href
        }
        return (
            <div>
                <Tooltip arrow title={Translate.tocList}>
                <IconButton
                    onClick={() => this.toggleDrawer()}
                    size="small"
                >
                    <TocRoundedIcon/>
                </IconButton>
                </Tooltip>
                <Drawer className={this.classes.readerDrawer} anchor={"right"} open={open} onClose={() => this.toggleDrawer()}>
                    <Tabs
                        value={this.state.tab}
                        onChange={this.handleTabChange.bind(this)}
                        variant="fullWidth"
                        indicatorColor="secondary"
                        textColor="primary"
                        className="tab-header"
                    >
                        <Tab value="toc" icon={<TocRoundedIcon fontSize="small"/>} label={Translate.tocList}/>
                        <Tab value="selections" icon={<BorderColorRoundedIcon fontSize="small" />} label={Translate.selections} />
                    </Tabs>
                    {
                        tab === "toc" ?
                            <List className="listing">
                                {
                                    chapters.map((item,index) => (
                                        <ListItem
                                            key={index}
                                            button
                                            className={current_href === item.href ? "toc-item active" : "toc-item"}
                                            onClick={() => this.handleClick(item.href)}
                                        >
                                            <ListItemText
                                                primary={item.label}
                                            />
                                            <ListItemSecondaryAction>
                                                <ChevronLeftRoundedIcon/>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }

                            </List>
                            :
                            <List className="listing">
                                {
                                    selections.map((item,index) => (
                                        <ListItem
                                            key={index}
                                        >
                                            <ListItemIcon>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => this.handleRemove(item)}
                                                >
                                                    <CloseRoundedIcon/>
                                                </IconButton>
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={item.text}
                                            />
                                            <ListItemSecondaryAction>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => this.handleShow(item)}
                                                >
                                                    <ChevronLeftRoundedIcon/>
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }

                            </List>
                    }


                </Drawer>
            </div>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(PlayerPage))));